import React, { ReactNode } from 'react';

import { AuthProvider } from './auth';
import { ProposalProvider } from './AppContext';
import { SignatureProvider } from './SignatureContext';
import { RetentionSignatureProvider } from './RetentionSignatureContext';

type AppProviderProps = {
  children: ReactNode;
};

const AppProvider: React.FC<AppProviderProps> = ({ children }) => (
  <AuthProvider>
    <ProposalProvider>
      <SignatureProvider>
        <RetentionSignatureProvider>{children}</RetentionSignatureProvider>
      </SignatureProvider>
    </ProposalProvider>
  </AuthProvider>
);

export { AppProvider };
